import React from 'react';
import PropTypes from 'prop-types';

import { Stack, Box, Typography, InfoFillIcon } from '@metarouter-private/mr-mui';

import WithTooltip from 'app/components/WithTooltip';
import buildBubbleClickProps from 'app/components/data-table/buildBubbleClickProps';

const TOOLTIP_TITLE = 'This pipeline contains CLI-managed integrations that will be preserved';

const BOX_PROPS = {
  display: 'flex',
  alignItems: 'center',
};

export default function PipelineNameCell({ name, unmanagedIntegrationsStatus }) {
  const bubbleClickProps = buildBubbleClickProps(true);

  const noUnmanagedIntegrations = unmanagedIntegrationsStatus === 'NONE';
  if (noUnmanagedIntegrations) {
    return (
      <Typography component="div" {...bubbleClickProps}>
        {name}
      </Typography>
    );
  }

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <WithTooltip Container={Box} ContainerProps={BOX_PROPS} show title={TOOLTIP_TITLE}>
        <InfoFillIcon color="info" />
      </WithTooltip>

      <Typography component="span" {...bubbleClickProps}>
        {name}
      </Typography>
    </Stack>
  );
}

PipelineNameCell.propTypes = {
  name: PropTypes.string.isRequired,
  unmanagedIntegrationsStatus: PropTypes.string.isRequired,
};
